module.exports = __webpack_public_path__ + "img/arr-left.0eac1ad4.svg";